import MapoRule from 'components/MapoAdministration/components/MapoRule';

const ScreenMapoRule = () => {
  return <MapoRule />;
};

export default ScreenMapoRule;
